<template>
  <div v-if="upInternalChat" id="internal-chat-main" class="internal-chat-main">
    <vs-popup
        :active.sync="audioNotAllowedPopupActive"
        class="chat-audio-not-allowed-popup"
        title="Permitir microfone"
    >
      <p>
        Para gravar mensagens de voz, precisamos ter acesso ao microfone de seu computador.
      </p>

      <div class="flex flex-wrap items-center justify-center">
        <vs-button
            class="mr-4 mt-4 sm:mb-0 mb-2"
            color="rgb(62, 201, 214)"
            type="filled"
            @click.prevent="audioNotAllowedPopupActive = false"
        >
          OK, ENTENDI.
        </vs-button>
      </div>
    </vs-popup>

    <vs-popup
        :active.sync="audioNotFoundPopupActive"
        class="chat-audio-not-found-popup"
        title="Microfone não encontrado"
    >
      <p>
        Você não pode gravar uma mensagem de voz porque parece que seu computador não tem um microfone.
        Tente conectar um microfone ou caso já o tenha conectado, reinicie seu navegador.
      </p>

      <div class="flex flex-wrap items-center justify-center">
        <vs-button
            class="mr-4 mt-4 sm:mb-0 mb-2"
            color="rgb(62, 201, 214)"
            type="filled"
            @click.prevent="audioNotFoundPopupActive = false"
        >
          OK, ENTENDI.
        </vs-button>
      </div>
    </vs-popup>

    <div class="header-internal-chat to-top bg-primary">
      <div>
        <div slot="title" class="navbarx">
          <feather-icon
              class="text-white cursor-pointer ml-2 pr-3"
              icon="ChevronLeftIcon"
              @click.stop="$emit('backInternalChat')">
          </feather-icon>

          <div>
            <vs-avatar class="avatar_user icon-navbar mr-2  border-2 border-solid border-white" v-if="selectedUser.image" :src="selectedUser.image"/>
            <vs-avatar class="avatar_user icon-navbar mr-2  border-2 border-solid border-white" v-else/>
          </div>

          <vs-navbar-title>
            <p class="username-user text-white">
              {{ selectedUser ? selectedUser.username : 'Chat Interno' }}
            </p>
          </vs-navbar-title>
          <feather-icon
              class="chevron-down-icon text-white cursor-pointer"
              icon="ChevronDownIcon"
              @click.stop="closeListChat">
          </feather-icon>
        </div>
      </div>

      <div class="chat__bg chat-content-area border border-solid d-theme-border-grey-light border-t-0 border-r-0 border-b-0">
        <div class="centerx" v-show="loading">
          <div class="fill-row">
            <div
                id="loading-customer-chats"
                class="vs-con-loading__container"
                style="height: 100%;"
            ></div>
          </div>
        </div>
        <div>
          <internal-chat-log
             :active-chat-user="selectedUser"
             :up-internal-chat="upInternalChat"
          />
        </div>
      </div>

      <div v-if="chatReplyMessage" class="replyMessage">
        <div class="truncate flex">
          <div>Repondendo a: {{ replyMessageFormated | truncate(15) }}...</div>
          <div class="cursor-pointer" @click="clearReplyMessage">(Fechar)</div>
        </div>
      </div>

      <div v-if="audioGridActive" class="internal-chat-record-audio flex">
        <vs-button
            class="button-audio-status"
            color="danger"
            type="filled"
            @click.prevent="cancelAudio"
        >
          <feather-icon
              class="icons-audio-style"
              icon="XCircleIcon"
          />
        </vs-button>

        <div class="counter-audio">
          <span>{{ formattedTime }}</span>
        </div>

        <vs-button
            class="button-audio-status"
            color="success"
            type="filled"
            @click.prevent="sendAudio"
        >
          <feather-icon class="icons-audio-style" icon="CheckCircleIcon"/>
        </vs-button>
      </div>
      <div class="chat">
        <div class="icons">
          <vs-dropdown class="dropdownFuncionality" vs-custom-content vs-trigger-click>
            <vs-button class="iconFuncionality icons" icon="add" radius/>
            <vs-dropdown-menu class="dropdown">
              <vs-dropdown-item>
                <div class="icons text-center" @click="popupActiveModal()">
                  <feather-icon class="cursor-pointer" icon="PaperclipIcon"/>
                  <p class="ml-2">Documentos</p>
                </div>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <textarea
              ref="textAreaInternal"
              v-model="typedMessage"
              class="textArea"
              placeholder="Digite sua mensagem..."
              style="width:190px; height: 64px;"
              @keydown.enter.prevent="onEnter"
          />
          <vs-button
              v-if="!audioGridActive"
              class="iconMic select-none"
              color="primary"
              icon="mic"
              size="large-md"
              type="flat"
              @click.prevent="recordAudio()"
          />
          <vs-button
              class="send select-none" icon="send"
              radius
              @click="sendMsg()"
          />
        </div>

        <div>
          <vs-popup
              :active.sync="popupActive"
              :class="{ 'upload-image-popup' : imageUrl.length > 0 && isInternalChatMessage }"
              title="Enviar Anexo"
              @close="closeImageModal"
          >
            <div class="upload-file">
              <Upload
                  ref="uploadComponentImage"
                  class="internal-chat-upload-image-popup"
                  :action="uploadApiUrl"
                  :headers="{Authorization: 'Bearer ' + bearer}"
                  :limit="10"
                  :isInternalChatMessage="true"
                  :multiple="true"
                  :single-upload="true"
                  :text="'Escolher Documento'"
                  automatic
                  fileName="file"
                  @on-success="successUploadFile"
                  @on-error="errorUploadFile"
                  @on-delete="deleteUploadFile"
              />
            </div>

            <div class="flex justify-content-center">
              <vs-button
                  type="filled"
                  @click.prevent="sendImage"
                  class="mr-4 mt-4 sm:mb-0 mb-2"
                  :disabled="imageUrl.length === 0"
              >
                Enviar Anexo
              </vs-button>
            </div>
          </vs-popup>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InternalChatLog from './InternalChatLog.vue';
import axios from "axios";
import Upload from '@/components/upload/Upload'
import ViewStockImages from '@/components/stock-image-card/ViewStockImages.vue'
import Button from "../../../components/button/Button.vue";
import VsDropdown from "../../../components/vs-dropdown/dropdown.vue";
import VsDropdownMenu from "../../../components/vs-dropdown/dropdown-menu.vue";
import VsDropdownItem from "../../../components/vs-dropdown/dropdown-item.vue";
import ChatLog from "../../../views/chat-attendance/ChatLog.vue";
import {encodeToBase64} from "../../../utils";


export default {
  name: "InternalChatMessage",
  components: {
    ChatLog,
    VsDropdownItem,
    VsDropdownMenu,
    VsDropdown,
    Button,
    Upload,
    ViewStockImages,
    InternalChatLog
  },
  props: {
    upInternalChat: {
      type: Boolean,
      required: true
    },
    selectedUser: {
      required: true,
      validator: prop => typeof prop === 'object' || prop === null
    }
  },
  data() {
    return {
      imageUrl: [],
      loading: false,
      popupActive: false,
      audioResend: [],
      audioChunks: [],
      audioSeconds: 0,
      imageCaption: null,
      canSendAudio: false,
      typedMessage: "",
      mediaRecorder: null,
      countImageSent: 0,
      audioGridActive: false,
      isSendingMessage: false,
      refreshIntervalId: null,
      audioNotFoundPopupActive: false,
      audioNotAllowedPopupActive: false,
      isInternalChatMessage: false,
    };
  },
  methods: {
    closeListChat() {
      this.$emit('closeListChat')
    },
    clearReplyMessage() {
      this.$store.dispatch('internalChatMessages/setReplyMessage', null);
    },
    popupActiveModal() {
      this.popupActive = true
    },
    closeImageModal() {
      this.popupActive = false;
      this.deleteUploadFile()
    },
    chatId(chat, index) {
      let cId = `chat-${chat.id}-${index}`
      if (chat.parentCustomerChat) {
        cId += '-' + chat.parentCustomerChat.id
      }
      return cId
    },
    successUploadFile(response) {
      const parsedResponse = JSON.stringify(response.data);
      if (parsedResponse === JSON.stringify(this.imageUrl)) {
        return;
      }

      this.imageUrl = JSON.parse(parsedResponse);

      this.$vs.notify({
        color: "success",
        title: "Anexo carregado com sucesso!",
        text: response.data.message,
      });
    },
    errorUploadFile(response) {
      this.$vs.notify({
        color: "danger",
        title: "Ocorreu um erro ao subir o anexo!",
        text: response.data && response.data.message ? response.data.message : ""
      });
    },
    deleteUploadFile(args = null) {
      this.imageCaption = null;

      if (args && args.method === "number") {
        const itemIndex = this.imageUrl.findIndex((index) => index.name === args.file.name)
        if (itemIndex !== -1) {
          return this.imageUrl.splice(itemIndex, 1);
        } else if (this.imageUrl.length > 0) {
          return
        }
      } else if (args === null) {
        this.$refs.uploadComponentImage.removeFile(null, true)
      }
      this.imageUrl = [];
    },
    sendImage(fileType = 'image', fileUrl = null) {
      this.isSendingMessage = true
      this.sendSeen()

      if (fileUrl) {
        fileUrl = [{url: fileUrl, name: ''}];
      } else {
        fileUrl = this.imageUrl;
      }

      this.popupActive = false
      if (document.getElementsByClassName('btn-x-file')[this.countImageSent] !== undefined) {
        document.getElementsByClassName('btn-x-file')[this.countImageSent].click()
      }

      fileUrl.forEach((file, index) => {
        this.countImageSent += 1
        this.submitFile(fileType, file.url, file.name, fileUrl.length === index + 1)
      });

      this.deleteUploadFile();
    },
    sendFile(fileType = 'audio', fileUrl = null) {
      this.isSendingMessage = true
      this.sendSeen()

      if (fileType !== 'audio') {
        if (document.getElementsByClassName('btn-x-file')[this.countImageSent] !== undefined) {
          document.getElementsByClassName('btn-x-file')[this.countImageSent].click()
        }
        this.countImageSent += 1
      }

      this.$store.dispatch('setShowLoadingOverlay', false);
      this.submitFile(fileType, fileUrl)

      this.deleteUploadFile();
    },
    submitFile(fileType, fileUrl, fileName = '', isLast = true) {
      const documentName = fileName ? fileName : this.imageCaption ? this.imageCaption : '';
      this.popupActive = false
      this.isSendingMessage = true

      this.$store.dispatch("internalChatMessages/sendImageInternalChatMessage", {
        from_chat: true,
        unseen_msg: false,
        image_url: fileUrl,
        tag_type: "document",
        document_name: documentName,
        user_id: this.selectedUser.id,
        user_sending_id: this.activeUser.id,
        parent_id: (this.chatReplyMessage) ? this.chatReplyMessage.id : null,
      }).then(() => {
        this.isSendingMessage = false
        this.clearReplyMessage()

        if ( isLast ){
          this.$vs.notify({
            color: 'success',
            title: `${fileType === 'audio' ? 'Audio' : 'Arquivo(s)'} encaminhado com sucesso!`,
          });
        }
      }).catch((error) => {
        console.error(error);

        this.isSendingMessage = false;
        this.$vs.loading.close('#chat-app > .con-vs-loading');

        this.$vs.notify({
          time: 8000,
          color: "danger",
          title: "Ocorreu um ao enviar a figurinha!",
          text: "Tente enviar a figurinha novamente em alguns instantes.",
        });

        this.popupActive = false;
      });
    },
    openAudioNotAllowedModal() {
      this.audioNotAllowedPopupActive = true;
    },
    openAudioNotFoundError() {
      this.audioNotFoundPopupActive = true;
    },
    sendAudio() {
      if (this.mediaRecorder && this.mediaRecorder.state == 'recording') {
        this.canSendAudio = true;
        this.mediaRecorder.stop();
        clearInterval(this.refreshIntervalId);
      }
      this.audioGridActive = false;
    },
    cancelAudio() {
      if (!this.mediaRecorder) {
        return
      }

      this.audioGridActive = false;
      if (this.mediaRecorder.state == 'recording') {
        this.canSendAudio = false;
        this.mediaRecorder.stop();
        clearInterval(this.refreshIntervalId);
      }
      this.mediaRecorder = null
    },
    recordAudio() {
      navigator.mediaDevices.getUserMedia({audio: true}).then(stream => {
        this.audioGridActive = true;
        this.mediaRecorder = new MediaRecorder(stream);
        this.mediaRecorder.start();

        this.refreshIntervalId = setInterval(() => {
          this.audioSeconds++;
        }, 1000);

        this.mediaRecorder.addEventListener("dataavailable", event => {
          this.audioChunks.push(event.data);
        });
        if (this.audioChunks) {
          this.audioResend = this.audioChunks
        }

        this.mediaRecorder.addEventListener("stop", () => {
          if ( this.canSendAudio ) {
            new Promise((resolve, reject) => {
              const audioBlob = new Blob(this.audioChunks, { 'type' : 'audio/mpeg-3' });
              const audioFile = new File([audioBlob], "audio.mp3");
              let formData = new FormData();
              formData.append('file', audioFile);

              axios.post(
                  this.uploadApiUrl,
                  formData,
                  { headers: {'Content-Type': 'multipart/form-data', 'Authorization': 'Bearer ' + this.bearer} }
              ).then(response => {
                this.sendFile('audio', response.data.fileUrl);
                resolve()
              }).catch(error => {
                if (error.name === 'NotAllowedError') {
                  this.openAudioNotAllowedModal();
                } else if (error.name === 'NotFoundError') {
                  this.openAudioNotFoundError();
                }

                this.audioResend = this.audioChunks
                this.cancelAudio();

                console.error(error);
                reject()
              });
            })
          }

          this.audioChunks = [];
          this.mediaRecorder = null;
          stream.getTracks().forEach(track => track.stop());
          this.audioSeconds = 0;
          this.canSendAudio = false;
        });
      });
    },
    sendMsg() {
      if (!this.typedMessage) { return; }

      const messageToSend = this.typedMessage;
      this.isSendingMessage = true;
      this.typedMessage = "";
      this.sendSeen()

      this.$store.dispatch("internalChatMessages/sendInternalChatMessage", {
        user_id: this.selectedUser.id,
        user_sending_id: this.activeUser.id,
        message: encodeToBase64(messageToSend),
        unseen_msg: false,
        tag_type: 'chat',
        parent_id: (this.chatReplyMessage) ? this.chatReplyMessage.id : null,
      }).then(() => {
        this.isSendingMessage = false;
        this.clearReplyMessage()
      }).catch((error) => {
        console.log(error);

        this.isSendingMessage = false;
        this.$vs.loading.close('#chat-app > .con-vs-loading');

        return this.$vs.notify({
          time: 8000,
          color: "danger",
          title: "Ocorreu um ao enviar a mensagem!",
          text: "Tente enviar a mensagem novamente em alguns instantes.",
        });
      })
    },
    async sendSeen(){
      this.$store.dispatch('internalChatMessages/resetUnseenInternalChatMessages', {
        userId: this.activeUser.id,
        userSendingId: this.selectedUser.id
      });
    },
    onEnter(event) {
      if (event.shiftKey) {
        this.typedMessage = this.onShiftEnter('textAreaInternal', this.typedMessage);
        return;
      }
      this.sendMsg();
    },
    onShiftEnter(obj, msg) {
      let tArea = this.$refs[obj];
      let startPos = tArea.selectionStart;
      let endPos = tArea.selectionEnd;

      msg = msg.substring(0, startPos) + '\n' + msg.substring(endPos, msg.length);
      setTimeout(() => {
        tArea.selectionStart = tArea.selectionEnd = startPos + 1;
      }, 10);

      return msg;
    },
  },
  computed: {
    uploadApiUrl() {
      return localStorage.getItem("baseUrl") + "/api/file/upload";
    },
    bearer() {
      return this.$store.state.auth.bearer;
    },
    activeUser() {
      return this.$store.state.AppActiveUser;
    },
    chatReplyMessage() {
      return this.$store.state.internalChatMessages ? this.$store.state.internalChatMessages.replyinternalChatMessage : null;
    },
    formattedTime() {
      let totalSeconds = parseInt(this.audioSeconds, 10);
      let hours = 0;
      if (totalSeconds >= 3600) {
        hours = Math.floor(totalSeconds / 3600);
        hours = hours < 10 ? "0" + hours : hours;
      } else {
        hours = 0;
      }

      let minutes = Math.floor((totalSeconds - (hours * 3600)) / 60);
      let seconds = totalSeconds - (hours * 3600) - (minutes * 60);

      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      if (totalSeconds >= 3600) {
        return hours + ':' + minutes + ':' + seconds;
      }
      return minutes + ':' + seconds;
    },
    replyMessageFormated(){
      if ( this.chatReplyMessage.document_name && (
          this.chatReplyMessage.tag_type === "document" || this.chatReplyMessage.tag_type === "image"
      )){
        return this.chatReplyMessage.document_name
      }
      else if (this.chatReplyMessage.tag_type === "audio"){
        return 'Audio'
      }
      return this.chatReplyMessage.message
    }
  },
  created() {
    this.$events.off('closeInternalChatMessageComponents')
    this.$events.on('closeInternalChatMessageComponents', () => {
      this.closeImageModal();
    })
  }
}

</script>

<style lang="scss">
@import "@/assets/scss/vuexy/apps/internal-chat.scss";

.internal-chat-upload-image-popup {
  .con-upload{
    display: flex;
    justify-content: center;
  }
  .con-img-upload {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
  }
}

.upload-image-popup div.vs-popup {
  width: 1200px !important;
}

</style>


